<template>
    <div class="items-center my-lg p-lg bg-white shadow flex justify-between rounded-xl">
        <div>
            Med markerade ({{ selectedAddresses.length }} st):
        </div>
        <div class="flex">
            <button
                type="button"
                class="btn btn-md is-primary"
                @click="$modal.show('confirm-adding-to-delivery-project')"
            >
                Lägg till
            </button>

            <adaptive-form-modal
                name="confirm-adding-to-delivery-project"
                primary-button-text="Lägg till"
                primary-button-class="is-primary"
                title="Lägg till adresser"
                method="post"
                :action="route('admin.delivery-projects.addresses.store', deliveryProject)"
                :redirect-to="route('admin.delivery-projects.addresses.index', deliveryProject)"
            >
                Lägg till följande adresser till leveransprojektet?

                <ul class="mt-lg">
                    <li v-for="address in selectedAddresses" :key="address.id">
                        <input
                            v-model="address.id"
                            type="hidden"
                            name="addresses[]"
                        >
                        {{ address.full_address_with_apartment_number }}
                    </li>
                </ul>
            </adaptive-form-modal>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            selectedAddresses: {
                required: true,
                type: Array,
            },
            deliveryProject: {
                required: true,
                type: Object,
            },
        },
    };
</script>
